var $ = (typeof window !== "undefined" ? window['jQuery'] : typeof global !== "undefined" ? global['jQuery'] : null),
    validate = require('jquery-validation'),
    OrderForm = function () {
        this.$orderForm = $('.module-order-form-2-step .order-form-modular');
        this.$termsErrorLabel = $('.module-order-form-2-step .order-form-modular .terms-error-label');
        this.$preSubmitButton = this.$orderForm.find('.pre-submit-button-wrapper input');
        this.$backToForm = this.$orderForm.find('.back-to-form');
        this.$fieldsWrapper = this.$orderForm.find('.order-form-fields-wrapper');
        this.$preSubmitWrapper = this.$orderForm.find('.pre-submit-content-wrapper');
    };

OrderForm.prototype.init = function () {

    var self = this;
    self.$orderForm.validate({
        errorPlacement: function (error, element) {
            if (element.attr('name') === 'terms') {
                error.appendTo(self.$termsErrorLabel);
            }
        }
    });


    $(self.$preSubmitButton).on('click', function (e) {
        e.preventDefault();

        // Validate at this stage as well as on submit
        if (self.$orderForm.valid()) {

            var $preSubmitForeName = self.$orderForm.find('input[name="firstName"]').val();
            var $preSubmitLastName = self.$orderForm.find('input[name="lastName"]').val();
            var $preSubmitAddress = self.$orderForm.find('input[name="invoiceAddress"]').val();
            var $preSubmitZipCode = self.$orderForm.find('input[name="invoiceZipcode"]').val();
            var $preSubmitCity = self.$orderForm.find('input[name="invoiceCity"]').val();
            var $preSubmitEmail = self.$orderForm.find('input[name="email"]').val();
            var $preSubmitPhone = self.$orderForm.find('input[name="cellphone"]').val();

            // Add house number only if present
            var $preSubmitHouseNo = self.$orderForm.find('input[name="invoiceHouseNo"]');
            if ($preSubmitHouseNo.length && $preSubmitHouseNo.val()) {
                $preSubmitAddress = $preSubmitAddress + ' ' + $preSubmitHouseNo.val();
            }

            self.$orderForm.find('.pre-submit-forename').html($preSubmitForeName);
            self.$orderForm.find('.pre-submit-lastname').html($preSubmitLastName);
            self.$orderForm.find('.pre-submit-address').html($preSubmitAddress);
            self.$orderForm.find('.pre-submit-zipcode').html($preSubmitZipCode);
            self.$orderForm.find('.pre-submit-city').html($preSubmitCity);
            self.$orderForm.find('.pre-submit-email').html($preSubmitEmail);
            self.$orderForm.find('.pre-submit-telephone').html($preSubmitPhone);

            // Hide fields wrapper
            self.$fieldsWrapper.hide();

            // Show pre-submit content wrapper
            self.$preSubmitWrapper.show();

        }

        // Scroll to top of form
        $('html, body').animate({
            scrollTop: (self.$orderForm.offset().top - $.fn.getHeaderHeight(40))
        }, 750);

    });

    // Back to form link
    self.$backToForm.on('click', function (e) {
        e.preventDefault();

        // Hide pre-submit content wrapper
        self.$preSubmitWrapper.hide();

        // Show fields wrapper
        self.$fieldsWrapper.show();
    });

    $(self.$orderForm).on('submit', function (e) {
        e.preventDefault();

        if (self.$orderForm.valid()) {

            var data = $(this).serialize();

            $.ajax({
                method: 'GET',
                url: NORVITAL.root + 'norvital/v1/order',
                dataType: 'json',
                data: data,
                beforeSend: function (xhr) {
                    xhr.setRequestHeader('X-WP-Nonce', NORVITAL.nonce);
                    self.$orderForm.find('input[type="submit"]').prop('disabled', true); // disable button
                },
                success: function (response) {
                    if (response.redirect) {
                        window.location.href = response.redirect;
                        return;
                    }

                    self.$orderForm.find('.message').html('Your order has been successfully submitted.');
                    self.$orderForm.find('.callout').addClass('success').fadeIn();
                },
                error: function (response) {
                    self.$orderForm.find('.message').html('There was an error creating your order. Please try again.');
                    self.$orderForm.find('.callout').addClass('warning').fadeIn();
                }

            });

        }

    });
};

module.exports = new OrderForm();
